import { CancelSaveButtons } from '@components/cancel-save-buttons';
import { createForm, useCreateFormStore } from '@components/form';
import { hideModal, Modal, useModal } from '@components/modal';
import { useScopedTranslate } from '@locale/translate';

import { useDuplicateIntegrationWebhook } from '../integrations-hooks';
import type { DuplicateWebhookData, IntegrationWebhook } from '../integrations-types';

export const useDuplicateIntegrationWebhookModal = () => useModal(DuplicateIntegrationWebhookModal);

const Form = createForm<DuplicateWebhookData>();

export const DuplicateIntegrationWebhookModal = ({ webhook }: { webhook: IntegrationWebhook }) => {
  const { t } = useScopedTranslate(locale);
  const formStore = useCreateFormStore();

  const duplicateMutation = useDuplicateIntegrationWebhook(webhook);

  const handleSubmit = async () => {
    await duplicateMutation.mutateAsync(formStore.getState().values as DuplicateWebhookData);
    hideModal();
  };

  return (
    <Modal>
      <Modal.SimpleHeader title={t('title')} />
      <Modal.Content>
        <Form store={formStore} onSubmit={handleSubmit}>
          <Form.TextField
            id="name"
            label={t('webhookName')}
            defaultValue={`${webhook.name} [${t('copy')}]`}
          />
        </Form>
      </Modal.Content>
      <Modal.Footer>
        <CancelSaveButtons
          alwaysShow
          onCancel={hideModal}
          onSave={handleSubmit}
          translationsOverride={{ save: t('confirm') }}
          isDisabled={duplicateMutation.isLoading}
        />
      </Modal.Footer>
    </Modal>
  );
};

const locale = {
  en: {
    title: 'Duplicate integration webhook',
    webhookName: 'Webhook name',
    copy: 'copy',
    confirm: 'Duplicate',
  },
};
